import { render, staticRenderFns } from "./AddSimulateResource.vue?vue&type=template&id=2bf82c26&scoped=true&"
import script from "./AddSimulateResource.vue?vue&type=script&lang=js&"
export * from "./AddSimulateResource.vue?vue&type=script&lang=js&"
import style0 from "./AddSimulateResource.vue?vue&type=style&index=0&id=2bf82c26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf82c26",
  null
  
)

export default component.exports